import { render, staticRenderFns } from "./Escola.vue?vue&type=template&id=dd088e5e&scoped=true&"
import script from "./Escola.vue?vue&type=script&lang=ts&"
export * from "./Escola.vue?vue&type=script&lang=ts&"
import style0 from "./Escola.vue?vue&type=style&index=0&id=dd088e5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd088e5e",
  null
  
)

export default component.exports